import { Col, Row, Skeleton } from 'antd'
import moment from 'moment'
import React from 'react'
import { FaPlane } from "react-icons/fa";

const DepartureReviewCard = ({ flightDetails, loading, setIsModalOpen }) => {

    return (
        <>
            <Skeleton
                paragraph={{ rows: 6, }}
                loading={loading}
                style={{ background: "#fff" }}
                className='p-4 mb-4'
            >
                <div className="card flights-accordion">
                    <div className="card-header">
                        <h3>{flightDetails?.tripInfos?.[0].daCity} - {flightDetails?.tripInfos?.[0]?.aaCity}</h3>
                        <p>{flightDetails?.tripInfos?.[0]?.stops === 0
                            ? "Non Stop"
                            : `${flightDetails?.tripInfos?.[0]?.stops} Stop`}
                            {" | All departure/arrival times are in local time"}
                        </p>

                    </div>
                    <div className="flights-list-item rounded-3 p-3 mb-4">
                        {flightDetails?.tripInfos?.[0]?.sI?.map((flightInfo, i) => (
                            <>
                                <Row
                                    gutter={20}
                                    key={i}
                                    className="gy-4 align-items-center justify-content-between"
                                >
                                    <Col flex="1 0 auto" xs={24}>
                                        <Row gutter={20}>
                                            <Col xl={24} md={24} className="mb-1">
                                                <div className="d-flex align-items-center mb-2">
                                                    <span className="label bg-light-danger text-danger me-2">
                                                        Departure
                                                    </span>
                                                    <span className="text-muted text-sm">
                                                        {moment(flightInfo?.dt).format(
                                                            "DD MMM YYYY, hh:mm A"
                                                        )}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xl={24} md={24}>
                                                <Row
                                                    gutter={20}
                                                    className="gx-lg-5 gx-3 gy-4 align-items-center"
                                                >
                                                    {/* Airline and Cabin Information */}
                                                    <Col md={6}>
                                                        <div className="d-flex align-items-center justify-content-start">
                                                            <div className="d-start fl-pic">
                                                                <img
                                                                    className="img-collection result-flight"
                                                                    src={`https://d1mmwnce2x2c2z.cloudfront.net/airline/${flightInfo?.fD?.aI?.code}.gif`}
                                                                    alt="logo"
                                                                />
                                                            </div>
                                                            <div className="d-end fl-title ps-2">
                                                                <div className="text-dark fw-medium">
                                                                    {flightInfo?.fD?.aI?.name}
                                                                </div>
                                                                <div className="text-sm text-muted">
                                                                    {
                                                                        flightDetails?.searchQuery
                                                                            ?.cabinClass
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>

                                                    {/* Departure Information */}
                                                    <Col xs={24} md={18}>
                                                        <Row
                                                            gutter={16}
                                                            className="row gx-3 justify-content-between"
                                                        >
                                                            <Col
                                                                xs={10}
                                                                className="flight-details-oneway"
                                                            >
                                                                <div className="time text-dark fw-bold">
                                                                    {moment(
                                                                        flightInfo?.dt
                                                                    ).format("HH:mm")}
                                                                </div>
                                                                <div className="city-code">
                                                                    {
                                                                        flightInfo?.da
                                                                            ?.cityCode
                                                                    }
                                                                </div>
                                                                <div className="city">
                                                                    {flightInfo?.da?.city}
                                                                </div>
                                                                <div className="airport-name">
                                                                    {flightInfo?.da?.name}
                                                                </div>
                                                                <div className="terminal">
                                                                    {
                                                                        flightInfo?.da
                                                                            ?.terminal
                                                                    }
                                                                </div>
                                                            </Col>

                                                            {/* Flight Duration */}
                                                            <Col
                                                                flex="auto"
                                                                className="text-center DurationFlight"
                                                            >
                                                                <small className="text-dark fw-medium">
                                                                    {" "}
                                                                    {moment
                                                                        .duration(
                                                                            flightInfo?.duration,
                                                                            "minutes"
                                                                        )
                                                                        .hours() +
                                                                        " H " +
                                                                        moment
                                                                            .duration(
                                                                                flightInfo?.duration,
                                                                                "minutes"
                                                                            )
                                                                            .minutes() +
                                                                        " M"}
                                                                </small>
                                                                <div className="flightLine departure">
                                                                    <FaPlane className="trip-plane" />
                                                                    <div></div>
                                                                    <div></div>
                                                                </div>
                                                            </Col>

                                                            {/* Arrival Information */}
                                                            <Col
                                                                xs={10}
                                                                className="flight-details-oneway text-end"
                                                            >
                                                                <div className="time text-dark fw-bold">
                                                                    {moment(
                                                                        flightInfo?.at
                                                                    ).format("HH:mm")}
                                                                </div>
                                                                <div className="city-code">
                                                                    {
                                                                        flightInfo?.aa
                                                                            ?.cityCode
                                                                    }
                                                                </div>
                                                                <div className="city">
                                                                    {flightInfo?.aa?.city}
                                                                </div>
                                                                <div className="airport-name">
                                                                    {flightInfo?.aa?.name}
                                                                </div>
                                                                <div className="terminal">
                                                                    {
                                                                        flightInfo?.aa
                                                                            ?.terminal
                                                                    }
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Col>

                                                    {/* Stops Information */}
                                                    <Col
                                                        md={3}
                                                        className={
                                                            flightInfo?.stops === 0
                                                                ? "d-none"
                                                                : ""
                                                        }
                                                    >
                                                        <div className="text-muted text-sm fw-medium">
                                                            {flightInfo?.stops}{" "}
                                                            {flightInfo?.stops === 1
                                                                ? "Stop"
                                                                : "Stops"}
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>

                                {/* Layover Section */}
                                {i < flightDetails?.tripInfos?.[0]?.sI?.length - 1 && (
                                    <Row className="gx-lg-5 gx-3 gy-4 align-items-center py-2 px-3">
                                        <Col xs={24} className="text-center">
                                            <div className="layover-container bg-light text-dark py-2">
                                                <span className="fw-medium">
                                                    Layover at{" "}
                                                    {
                                                        flightDetails.tripInfos[0].sI[
                                                            i + 1
                                                        ]?.da?.name
                                                    }
                                                </span>
                                                <br />
                                                <small>
                                                    Duration:{" "}
                                                    {moment
                                                        .duration(
                                                            flightDetails.tripInfos[0].sI[
                                                                i
                                                            ]?.cT,
                                                            "minutes"
                                                        )
                                                        .hours() +
                                                        " h " +
                                                        moment
                                                            .duration(
                                                                flightDetails.tripInfos[0]
                                                                    .sI[i]?.cT,
                                                                "minutes"
                                                            )
                                                            .minutes() +
                                                        " m"}
                                                </small>
                                            </div>
                                        </Col>
                                    </Row>
                                )}
                            </>
                        ))}


                    </div>

                    <div className="card-footer">
                        <span className="d-flex flex-wrap align-items-center justify-content-center">
                            <span className="text-muted me-2">Baggage :- </span>
                            <div>
                                <svg width="15px" height="15px" fill="none" xmlns="http://www.w3.org/2000/svg" className="me-1">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M8.102 2.224H7.069V.948h.398c.251 0 .443-.205.443-.474S7.718 0 7.467 0H2.565c-.251 0-.443.205-.443.474s.192.474.443.474h.398v1.276H1.93c-.9 0-1.637.79-1.637 1.754v8.43c0 .964.738 1.754 1.637 1.754h.015v.143c0 .379.295.695.65.695h.324c.354 0 .649-.316.649-.695v-.143H6.42v.143c0 .379.295.695.649.695h.324c.355 0 .65-.316.65-.695v-.143h.014c.9 0 1.638-.79 1.638-1.754v-8.43c.059-.964-.679-1.754-1.593-1.754zM6.184.948v1.276H3.863V.948h2.32zM3.06 5.1c0-.268.128-.474.295-.474.158 0 .296.222.296.474v6.17c0 .269-.128.474-.296.474-.167 0-.295-.205-.295-.474V5.1zm2.045-.412c-.167 0-.295.205-.295.474v6.169c0 .269.128.474.295.474.168 0 .296-.205.296-.474v-6.17c0-.252-.128-.473-.296-.473zm1.455.474c0-.269.128-.474.295-.474.168 0 .296.22.296.474v6.169c0 .269-.128.474-.296.474-.167 0-.295-.205-.295-.474v-6.17z" fill="#222"></path>
                                </svg>
                                {flightDetails?.tripInfos?.[0]?.totalPriceList?.[0]?.fd?.ADULT?.bI?.iB} <span className="text-muted ms-1 me-3"> Cabin </span>
                            </div>
                            <div>
                                <svg width="15px" height="15px" fill="none" xmlns="http://www.w3.org/2000/svg" className=" me-1">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M6.388 5.625a.28.28 0 01-.174-.062c-.31-.246-3.034-2.455-3.034-4C3.18 0 5.837 0 6.97 0c1.135 0 3.792 0 3.792 1.563 0 1.544-2.724 3.754-3.035 4a.28.28 0 01-.173.062H6.388zm5.622.28a.276.276 0 00-.313.04.327.327 0 00-.098.32c.144.593.214 1.2.214 1.861l.002.563c.007 1.177.015 3.267-.25 4.544a.323.323 0 00.125.329.276.276 0 00.33-.007c.645-.496.96-.944.96-1.368V7.814c0-.929-.327-1.57-.97-1.907zM2.127 8.689l.003-.563c0-.66.07-1.268.213-1.86a.325.325 0 00-.098-.32.278.278 0 00-.313-.04c-.642.338-.97.98-.97 1.907v4.375c0 .424.315.872.96 1.368a.276.276 0 00.33.007c.102-.071.151-.202.125-.329-.265-1.277-.257-3.367-.25-4.545zm.745-3.954c.226-.539.376-.929.41-1.417a.33.33 0 00-.044-.19L3.19 3.05l-.013-.021c-.016-.027-.032-.053-.046-.08a.29.29 0 00-.28-.155.296.296 0 00-.248.207 9.344 9.344 0 00-.413 1.87.312.312 0 00.212.34.277.277 0 00.078.012c.113 0 .22-.071.267-.187l.124-.302zm8.465-1.732c.197.589.335 1.216.412 1.864a.314.314 0 01-.211.34.284.284 0 01-.079.012.292.292 0 01-.267-.186l-.122-.297c-.226-.54-.376-.93-.41-1.418a.328.328 0 01.043-.19l.107-.177a.293.293 0 01.279-.154c.114.012.21.092.248.207zm.01 5.123c0-1.478-.368-2.359-.692-3.135l-.001-.002c-.081-.193-.16-.38-.23-.572a.298.298 0 00-.215-.193.281.281 0 00-.268.092 15.365 15.365 0 01-1.866 1.75.867.867 0 01-.228.127v1.365c.338.13.338.442-.001.57 0 0-.131.058-.292.058H6.386c-.16 0-.292-.057-.292-.057-.337-.13-.337-.442.002-.571V6.192a.874.874 0 01-.23-.126c-.4-.319-1.173-.968-1.865-1.751a.285.285 0 00-.268-.092.3.3 0 00-.216.193c-.066.182-.14.36-.216.542l-.012.03-.001.002c-.324.776-.692 1.657-.692 3.135l-.002.568c-.012 1.994-.026 4.475 1.063 5.648.406.437.932.659 1.564.659h3.5c.633 0 1.159-.222 1.565-.659 1.089-1.173 1.074-3.654 1.063-5.648l-.003-.568zM7.263 6.25H6.68V7.5h.584V6.25z" fill="#222"></path>
                                </svg>
                                {flightDetails?.tripInfos?.[0]?.totalPriceList?.[0]?.fd?.ADULT?.bI?.cB}  <span className="text-muted mx-1"> Check-In </span>
                            </div>
                            <button type='link' onClick={() => setIsModalOpen(true)} className='read-more-button mt-2 mt-md-0 ms-md-4' aria-label="view baggage details">View Baggage Details</button>
                        </span>


                    </div>

                </div>
            </Skeleton >
        </>
    )
}


export default DepartureReviewCard